import { createContext } from 'react'
import { Customer } from '../../../gql/graphql'

export type FestivalContextType = {
  festival: Customer | null
  festivals: Customer[]
  selectFestival: (id: string) => void
}

export const FestivalContextValue = createContext<FestivalContextType | null>(null)
